/* eslint-disable import/no-import-module-exports */
import ReactDOM from 'react-dom/client';
import './_index.scss';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from 'components/common';
import { AuthProvider } from 'context/AuthContext';
import { store } from './app/store';
import { App } from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </HelmetProvider>
  </Provider>,
);

if (module.hot) {
  module.hot.accept();
}
